import * as React from 'react';
import styled from 'styled-components';
import ArrowDownBase from './ArrowDown';
import ArrowRightBase from './ArrowRight';

const DetailsOfRetrieval = () => {
  return (
    <>
      <ArrowDown />
      <ArrowRight />
    </>
  );
};

const ArrowDown = styled(ArrowDownBase)`
  @media ${({ theme }) => theme.queries.minTablet} {
    display: none;
  }

  margin: 5px 0 5px 50px;
`;

const ArrowRight = styled(ArrowRightBase)`
  @media ${({ theme }) => theme.queries.mobile} {
    display: none;
  }

  margin: 0 12px;
`;

export default DetailsOfRetrieval;
